<template>
  <div
    class="inline-flex relative rounded-full overflow-hidden text-enterprise-primary"
    :style="{ background: color }"
  >
    <!-- Extra relative element to help respect parent padding -->
    <div class="relative w-full h-full">
      <img
        v-if="src && srcAvailable"
        class="absolute inset-0 m-auto object-contain"
        :src="src"
      />

      <span
        v-if="icon && !srcAvailable"
        class="icon absolute inset-0"
        :class="{ 'p-1': padIcon }"
        v-html="icon"
      />

      <div v-show="text">
        <div
          class="absolute inset-0 flex justify-center items-center text-xl font-medium leading-none mt-0.5"
        >
          {{ text }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    color: { type: String, default: '#efefef' },
    padIcon: { type: Boolean, default: true },
    icon: { type: String, default: '' },
    text: { type: String, default: '' },
    src: { type: String, default: '' },
  },

  data: () => ({
    srcAvailable: false,
  }),

  watch: {
    async src(newSrc) {
      await this.validateSrc(newSrc)
    },
  },

  async mounted() {
    await this.validateSrc(this.src)
  },

  methods: {
    async validateSrc(src) {
      if (!src) return false
      try {
        const response = await this.$api.get(src)
        if (response.status === 200) {
          this.srcAvailable = true
        }
      } catch (error) {
        this.srcAvailable = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.icon /deep/ svg {
  @apply w-full;
}
</style>
